const products = [
  {
    id: 1,
    category: "Shuttering",
    name: "MS Shuttering Plate",
    description: "High-quality MS Shuttering plates available in multiple sizes for concrete construction.",
    specs: ["Material: Mild Steel", "Thickness: 2mm - 3mm"],
    sizes: ["3FT x 2FT", "3FT x 1.5FT", "3FT x 1FT", "3FT x 9INCH (Adjustable)"],
    image: "/Product images/MS Shuttering Plate.png"
  },
  {
    id: 2,
    category: "Shuttering",
    name: "MS Channel",
    description: "Durable MS Channels for structural support, available in different lengths.",
    specs: ["Material: Mild Steel"],
    sizes: ["8FT", "9FT", "10FT"],
    image: "/Product images/MS Channel.png"
  },
  {
    id: 3,
    category: "Props",
    name: "Adjustable Steel Prop",
    description: "Heavy-duty adjustable steel props for slab support in various heights.",
    specs: ["Material: Steel", "Load Capacity: High"],
    sizes: ["2MTR x 2MTR", "2MTR x 3MTR", "3MTR x 3MTR"],
    image: "/Product images/Adjustable Steel Prop .png"
  },
  {
    id: 5,
    category: "Scaffolding",
    name: "Cuplock Standard",
    description: "Vertical members of the cuplock scaffolding system, available in multiple lengths.",
    specs: ["Material: High-strength Steel", "Type: Vertical"],
    sizes: ["500MM", "1MTR", "1.5MTR", "2MTR", "2.5MTR", "3MTR"],
    image: "/Product images/Cuplock Standard.png"
  },
  {
    id: 6,
    category: "Scaffolding",
    name: "Cuplock Ledger",
    description: "Horizontal members for scaffolding systems, available in various sizes.",
    sizes: ["2MTR", "1.5MTR", "1.2MTR", "1MTR", "870MM", "500MM"],
    image: "/Product images/Cuplock Ledger.png"
  },
  {
    id: 7,
    category: "Jacks",
    name: "Base Jack",
    description: "Solid base jacks for scaffolding stability.",
    image: "/Product images/Base Jack.png"
  },
  {
    id: 8,
    category: "Jacks",
    name: "U Head Jack",
    description: "U head jacks for beam support.",
    image: "/Product images/U Head Jack.png"
  },
  {
    id: 10,
    category: "Accessories",
    name: "Swivel Coupler",
    description: "Heavy duty couplers for pipe connection at any angle.",
    image: "/Product images/Swivel Coupler.png"
  },
  {
    id: 11,
    category: "Accessories",
    name: "Joint Pin",
    description: "Essential pins for scaffolding joints.",
    image: "/Product images/Joint Pin.png"
  },
  {
    id: 13,
    category: "Scaffolding",
    name: "MS Pipe (Scaffold Tube)",
    description: "Standard MS pipes for versatile construction and scaffolding needs.",
    sizes: ["20FT"],
    image: "/Product images/Scaffold Tube.png"
  },
  {
    id: 19,
    category: "Scaffolding",
    name: "Steel Challi",
    description: "Durable steel challis for scaffolding platforms.",
    sizes: ["6FT"],
    image: "/Product images/Steel Challi.png.jpeg"
  },
  {
    id: 14,
    category: "Accessories",
    name: "Scaffolding Clamp",
    description: "Right-angle coupler for securing scaffold tubes.",
    image: "/Product images/Double Coupler.png"
  },
  {
    id: 20,
    category: "Shuttering",
    name: "Shuttering shikanja",
    description: "High-quality MS Shikanja for column and beam shuttering.",
    sizes: ["2FT", "2.5FT", "3FT"],
    image: "/Product images/Shuttering shikanja.png.jpeg"
  },
  {
    id: 21,
    category: "Shuttering",
    name: "Pharma column",
    description: "Precision-made MS Farma plates for column construction.",
    sizes: ["9INCH", "12INCH", "15INCH", "18INCH", "21INCH", "24INCH", "27INCH", "30INCH", "33INCH"],
    image: "/Product images/Pharma Column.jpeg"
  }
];

export const categories = [
  "Shuttering",
  "Props",
  "Scaffolding",
  "Jacks",
  "Accessories",
  "Other Hardware"
];

export default products;